<template>
	<TransactionalEmailTabLayout v-bind="transactionalEmailProps" />
</template>

<script>
import TransactionalEmailTabLayout from './TransactionalEmailTabLayout';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';
import { setParamInEditNode } from '@/store/modules/selectedNode/actions';
import { flatPreviousSteps, editNode } from '@/store/modules/selectedNode/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'TransactionalEmailTabDataProvider',
	components: { TransactionalEmailTabLayout },
	props: {},
	mounted() {},
	computed: {
		...mapGettersShorthand({ editNode, flatPreviousSteps }),
		paramsMap() {
			return this.editNode?.params_map;
		},
		transactionalEmailProps() {
			const emailTemplateMetadataParams = this.paramsMap?.email_template_metadata?.params || {};
			let processedEmailTemplateParams = {};
			if (Object.values(emailTemplateMetadataParams).length) {
				const entries = Object.entries(emailTemplateMetadataParams).map(([key, value]) => [
					key,
					WidgetFormService.processPreviousSteps(value, this.flatPreviousSteps),
				]);
				processedEmailTemplateParams = Object.fromEntries(entries);
			}
			return { processedEmailTemplateParams };
		},
	},
	methods: {
		...mapActionsShorthand({ setParamInEditNode }),
	},
};
</script>

<style scoped lang="scss"></style>
